/* eslint-disable global-require */
const Singin = r => require.ensure([], () => r(require('./Main')), 'auth-bundle')

export default [
  {
    name: 'auth.singin',
    path: '/auth/singin',
    component: Singin
  }
]



// WEBPACK FOOTER //
// ./src/app/auth/routes.js